
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestApi } from 'app/auth/rest.api';

@Injectable()
export class SecurityService {

    authorizationUrl = 'api/authorization';
    constructor(private _authHttp: RestApi) { }

    getParameters(type: string): Observable<any> {
        return this._authHttp.get(`${this.authorizationUrl}/${type}`);
    }
}

